export const reportTypes = {
  VIEWS: 'views',
  ENGAGEMENT: 'engagements',
  CTA: 'clicks',
  OPENED: 'opened-emails',
  DELIVERED: 'delivered-emails',
  DEFERRED: 'deferred-emails',
  SPAM: 'spam-emails',
  BOUNCED: 'bounced-emails',
  DROPPED: 'dropped-emails',
  UNSUBSCRIBED: 'unsubscribed-emails',
  RECORDED: 'videos',
  SENT: 'sent-emails',
  VIDEO_ATTRIBUTES: 'video-attributes',
  AVERAGE_VIDEO_DURATION: 'average-video-duration',
  LAST_LOGIN: 'lastLogin',
  // CDS report types
  REPAIR_ORDER: 'repair-orders',
  TOTAL_RO_ITEMS: 'total-ro-items',
  REQUIRED_RO_ITEMS: 'required-ro-items',
  OPTIONAL_RO_ITEMS: 'optional-ro-items',
  TOTAL_AMOUNT: 'total-amount',
  AMOUNT_APPROVED: 'amount-approved',
  CLOSE_RATIO: 'close-ratio',
};

export const reportFieldType = {
  COUNT: 'cnt',
  AVERAGE: 'average',
  MAX: 'max',
};

export const reportData = {
  [reportTypes.RECORDED]: {
    label: 'Recorded Videos',
    url: 'metrics/reports/videos',
    field: reportFieldType.COUNT,
    isPercentage: false,
    tableFields: [
      {
        value: 'title',
        label: 'Video Title',
      },
      {
        value: 'recordedAt',
        label: 'Date Recorded',
      },
    ],
  },
  [reportTypes.VIEWS]: {
    label: 'Total Views',
    url: 'metrics/reports/views',
    field: reportFieldType.COUNT,
    isPercentage: false,
    tableFields: [
      {
        value: 'title',
        label: 'Video Title',
      },
      {
        value: 'contactName',
        label: 'Name',
      },
      {
        value: 'email',
        label: 'Email Address',
      },
      {
        value: 'date',
        label: 'Date Viewed',
      },
      {
        value: 'watched',
        label: 'Watched %',
      },
    ],
  },
  [reportTypes.CTA]: {
    label: 'CTA Clicks',
    url: 'metrics/reports/clicks',
    field: reportFieldType.COUNT,
    isPercentage: false,
    tableFields: [
      {
        value: 'date',
        label: 'Click Date',
      },
      {
        value: 'email',
        label: 'Email Address',
      },
      {
        value: 'cta',
        label: 'CTA',
      },
      {
        value: 'linkSet',
        label: 'CTA Set',
      },
      {
        value: 'template',
        label: 'Landing Page',
      },
    ],
  },
  [reportTypes.ENGAGEMENT]: {
    label: 'Engagement Rate',
    url: 'metrics/reports/engagements',
    field: reportFieldType.AVERAGE,
    isPercentage: true,
    tableFields: [
      {
        value: 'contactName',
        label: 'Name',
      },
      {
        value: 'email',
        label: 'Email Address',
      },
      {
        value: 'title',
        label: 'Video Title',
      },
      {
        value: 'date',
        label: 'Date Viewed',
      },
      {
        value: 'watched',
        label: 'Watched %',
      },
    ],
  },
  [reportTypes.OPENED]: {
    label: 'Opened',
    url: 'metrics/reports/opened-emails',
    field: reportFieldType.COUNT,
    isPercentage: false,
    tableFields: [
      {
        value: 'contactFullName',
        label: 'Name',
      },
      {
        value: 'email',
        label: 'Email Address',
      },
      {
        value: 'date',
        label: 'Date Sent',
      },
      {
        value: 'title',
        label: 'Video Title',
      },
      {
        value: 'status',
        label: 'View Status',
      },
      {
        value: 'lastViewDate',
        label: 'Last Viewed',
      },
    ],
  },
  [reportTypes.DELIVERED]: {
    label: 'Delivered',
    url: 'metrics/reports/delivered-emails',
    field: reportFieldType.COUNT,
    isPercentage: false,
    tableFields: [
      {
        value: 'contactFullName',
        label: 'Name',
      },
      {
        value: 'email',
        label: 'Email Address',
      },
      {
        value: 'date',
        label: 'Date Sent',
      },
      {
        value: 'title',
        label: 'Video Title',
      },
      {
        value: 'status',
        label: 'View Status',
      },
      {
        value: 'lastViewDate',
        label: 'Last Viewed',
      },
    ],
  },
  [reportTypes.DEFERRED]: {
    label: 'Deferred',
    url: 'metrics/reports/deferred-emails',
    field: reportFieldType.COUNT,
    isPercentage: false,
    tableFields: [
      {
        value: 'name',
        label: 'Name',
      },
      {
        value: 'email',
        label: 'Email Address',
      },
      {
        value: 'date',
        label: 'Date Deferred',
      },
    ],
  },
  [reportTypes.SPAM]: {
    label: 'Spam',
    url: 'metrics/reports/spam-emails',
    field: reportFieldType.COUNT,
    isPercentage: false,
    tableFields: [
      {
        value: 'name',
        label: 'Name',
      },
      {
        value: 'email',
        label: 'Email Address',
      },
      {
        value: 'date',
        label: 'Date',
      },
    ],
  },
  [reportTypes.BOUNCED]: {
    label: 'Bounced',
    url: 'metrics/reports/bounced-emails',
    field: reportFieldType.COUNT,
    isPercentage: false,
    tableFields: [
      {
        value: 'name',
        label: 'Name',
      },
      {
        value: 'email',
        label: 'Email Address',
      },
      {
        value: 'date',
        label: 'Date Bounced',
      },
    ],
  },
  [reportTypes.DROPPED]: {
    label: 'Dropped',
    url: 'metrics/reports/dropped-emails',
    field: reportFieldType.COUNT,
    isPercentage: false,
    tableFields: [
      {
        value: 'name',
        label: 'Name',
      },
      {
        value: 'email',
        label: 'Email Address',
      },
      {
        value: 'date',
        label: 'Date Dropped',
      },
    ],
  },
  [reportTypes.UNSUBSCRIBED]: {
    label: 'Unsubscribed',
    url: 'metrics/reports/unsubscribed-emails',
    field: reportFieldType.COUNT,
    isPercentage: false,
    tableFields: [
      {
        value: 'name',
        label: 'Name',
      },
      {
        value: 'email',
        label: 'Email Address',
      },
      {
        value: 'date',
        label: 'Date Unsubscribed',
      },
    ],
  },
  [reportTypes.SENT]: {
    label: 'Sent',
    url: 'metrics/reports/sent-emails',
    field: reportFieldType.COUNT,
    isPercentage: false,
    tableFields: [
      {
        value: 'contactFullName',
        label: 'Name',
      },
      {
        value: 'email',
        label: 'Email Address',
      },
      {
        value: 'date',
        label: 'Date Sent',
      },
      {
        value: 'title',
        label: 'Video Title',
      },
      {
        value: 'status',
        label: 'View Status',
      },
      {
        value: 'lastViewDate',
        label: 'Last Viewed',
      },
    ],
  },
  [reportTypes.VIDEO_ATTRIBUTES]: {
    label: 'Video Attributes',
    url: 'metrics/reports/video-attributes',
    field: reportFieldType.COUNT,
    isPercentage: false,
    tableFields: [
      {
        value: 'title',
        label: 'Attribute Name',
      },
      {
        value: 'attributeType',
        label: 'Type',
      },
      {
        value: 'valueCount',
        label: 'Values',
      },
      {
        value: 'videoCount',
        label: 'Total Videos',
      },
    ],
  },
  [reportTypes.AVERAGE_VIDEO_DURATION]: {
    label: 'Avg Video duration (Seconds)',
    url: 'metrics/reports/average-video-duration',
    field: reportFieldType.AVERAGE,
    isPercentage: false,
    tableFields: [
      {
        value: 'userFullName',
        label: 'Name',
      },
      {
        value: 'email',
        label: 'Email Address',
      },
      {
        value: 'duration',
        label: 'Duration',
      },
    ],
  },
  [reportTypes.LAST_LOGIN]: {
    label: 'Last Login',
    hideWidget: true,
    tableFields: [],
  },
  [reportTypes.REPAIR_ORDER]: {
    label: 'No. of ROs',
    url: 'metrics/reports/repair-orders',
    field: reportFieldType.COUNT,
    isPercentage: false,
    tableFields: [
      {
        value: 'advisorName',
        label: 'Advisor name',
      },
      {
        value: 'date',
        label: 'Date',
      },
    ],
    isAutomotive: true,
  },
  [reportTypes.TOTAL_RO_ITEMS]: {
    label: 'Total RO items',
    url: 'metrics/reports/total-ro-items',
    field: reportFieldType.COUNT,
    isPercentage: false,
    tableFields: [
      {
        value: 'advisorName',
        label: 'Advisor name',
      },
      {
        value: 'title',
        label: 'RO Title',
      },
      {
        value: 'date',
        label: 'Date',
      },
    ],
    isAutomotive: true,
  },
  [reportTypes.REQUIRED_RO_ITEMS]: {
    label: 'Req RO items',
    url: 'metrics/reports/required-ro-items',
    field: reportFieldType.COUNT,
    isPercentage: false,
    tableFields: [
      {
        value: 'advisorName',
        label: 'Advisor name',
      },
      {
        value: 'title',
        label: 'RO Title',
      },
      {
        value: 'date',
        label: 'Date',
      },
    ],
    isAutomotive: true,
  },
  [reportTypes.OPTIONAL_RO_ITEMS]: {
    label: 'Opt RO items',
    url: 'metrics/reports/optional-ro-items',
    field: reportFieldType.COUNT,
    isPercentage: false,
    tableFields: [
      {
        value: 'advisorName',
        label: 'Advisor name',
      },
      {
        value: 'title',
        label: 'RO Title',
      },
      {
        value: 'date',
        label: 'Date',
      },
    ],
    isAutomotive: true,
  },
  [reportTypes.TOTAL_AMOUNT]: {
    label: 'Total amount',
    url: 'metrics/reports/total-amount',
    field: reportFieldType.COUNT,
    isPercentage: false,
    tableFields: [
      {
        value: 'advisorName',
        label: 'Advisor name',
      },
      {
        value: 'title',
        label: 'RO Title',
      },
      {
        value: 'date',
        label: 'Date',
      },
      {
        value: 'price',
        label: 'Price',
      },
    ],
    isAutomotive: true,
  },
  [reportTypes.AMOUNT_APPROVED]: {
    label: 'Amount approved',
    url: 'metrics/reports/amount-approved',
    field: reportFieldType.COUNT,
    isPercentage: false,
    tableFields: [
      {
        value: 'advisorName',
        label: 'Advisor name',
      },
      {
        value: 'title',
        label: 'RO Title',
      },
      {
        value: 'date',
        label: 'Date',
      },
      {
        value: 'price',
        label: 'Price',
      },
    ],
    isAutomotive: true,
  },
  [reportTypes.CLOSE_RATIO]: {
    label: 'Close ratio',
    url: 'metrics/reports/close-ratio',
    field: reportFieldType.MAX,
    isPercentage: false,
    tableFields: [
      {
        value: 'advisorName',
        label: 'Advisor name',
      },
      {
        value: 'date',
        label: 'Date',
      },
      {
        value: 'ratio',
        label: 'Close ratio',
      },
    ],
    allowDecimals: true,
    isAutomotive: true,
  },
};
